module.exports = __webpack_public_path__ + "static/media/1.0de21520.jpg";